/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/no-mobile-1218393': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.29 17.71a1 1 0 001.42 0 1.15 1.15 0 00.21-.33.94.94 0 000-.76 1.15 1.15 0 00-.21-.33 1 1 0 00-1.42 0 1.15 1.15 0 00-.21.33.94.94 0 000 .76 1.15 1.15 0 00.21.33zM8.66 4H16a1 1 0 011 1v7.34a1 1 0 002 0V5a3 3 0 00-3-3H8.66a1 1 0 000 2zm13.05 16.29l-18-18a1 1 0 00-1.42 1.42L5 6.41V19a3 3 0 003 3h8a3 3 0 002.76-1.83l1.53 1.54a1 1 0 001.42 0 1 1 0 000-1.42zM17 19a1 1 0 01-1 1H8a1 1 0 01-1-1V8.41l10 10z"/>'
  }
})
